export default {"src":"/_next/static/image/src/components/ComparisonChart/dark_icon.57d1ef97ef5a1c9b5d13303caf359261.svg","height":35,"width":36};